<template>
  <!-- 头像部分 -->
  <div>
    <!-- 头像 -->
    <div class="portrait">
      <img @click="goToPersonalCenter" class="portraits" :src="url" alt="" />
      <div :class="{ redDot: msg }"></div>
      <img
        class="info"
        @click="CancelMsg"
        src="../../../../assets/img/评论.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "headerPortrait",
  props: {
    msg: {
      type: Boolean
    },
    url: {
      type: String
    }
  },
  methods: {
    goToPersonalCenter() {
      this.$emit("personalCenter");
    },
    // 取消消息
    CancelMsg() {
      this.$emit("CancelMsg");
    }
  }
};
</script>

<style lang="less" scoped>
// 红色小点
.redDot {
  width: 8px;
  height: 8px;
  background: #ff1616;
  border-radius: 50%;
  position: absolute;
  top: 11px;
  right: 8px;
}
.portrait {
  position: relative;
  display: flex;
  margin-left: 40px;
  // width: 46px;
  height: 46px;

  .portraits {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    cursor: pointer;
  }
  .info {
    cursor: pointer;
    margin-left: 18px;
    margin-right: 10px;
    margin-top: 13px;
    width: 24px;
    height: 22px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/front/frontHome/components/headerPortrait.vue